import { useEffect, useState } from "react";
import Lenis from "lenis";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import BrandCards from "./components/BrandCards";
import Manifesto from "./components/Manifesto";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import ComingSoonModal from "./components/ComingSoonModal";
import { Toaster } from "./components/ui/sonner";

function App() {
    const [pendingBrand, setPendingBrand] = useState(null);

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.08, smoothWheel: true, anchors: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <div id="top" className="min-h-screen bg-[#050507] text-slate-100">
            <div className="grain-overlay" aria-hidden="true" />
            <Header />
            <main>
                <Hero onComingSoon={setPendingBrand} />
                <Marquee />
                <BrandCards onComingSoon={setPendingBrand} />
                <Manifesto />
                <ContactSection />
            </main>
            <Footer />
            <ComingSoonModal brand={pendingBrand} onClose={() => setPendingBrand(null)} />
            <Toaster position="bottom-center" theme="dark" />
        </div>
    );
}

export default App;
